import React from 'react';


const FeatureItem = ({ icon: Icon, title, description }) => {
    return (
        <div className="group p-6 rounded-2xl hover:bg-gray-50 transition-colors">
            <div className="w-16 h-16 bg-purple-50 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-100 transition-colors">
                <Icon className="w-8 h-8 text-purple-900" />
            </div>
            <h3 className="serif text-lg font-bold mb-2">{title}</h3>
            <p className="text-sm text-gray-500 leading-relaxed">{description}</p>
        </div>
    );
};

export default FeatureItem;
